import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Modal,
  Button,
  Card,
  Spinner,
  Row,
  Col,
  Form,
  Table,
} from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../../redux/auth/actions";
import toastr from "toastr";
import { getResponsables } from "../../redux/climalaboral/campaña/action";
import {
  getMonitor,
  saveCopia,
} from "../../redux/on&offBoarning/monitor/actions";

const WorkFlowEmployeesCopiaMasiva = (props) => {
  //*States
  const [userSelected, setUserSelected] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isUserValid, setIsUserValid] = useState(false);
  const [workflowUsers, setWorkflowUsers] = useState([]);
  const [isResponsableValid, setIsResponsableValid] = useState(false);
  const [responsableSelected, setResponsableSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debounceTimeout = useRef(null);
  //*Redux
  const { loadingAuth, users } = useSelector((store) => store.auth);
  const { loadingWorkFlow, saveLoading } = useSelector(
    (store) => store.wflowempleados
  );
  const userRoles = useSelector((store) => store.auth.userRoles);

  const responsable = useSelector((store) => store.campaña.responsable);
  const responsableLoading = useSelector(
    (store) => store.campaña.responsablesLoading
  );
  const { copiaError } = useSelector((store) => store.monitorOnBoarding);

  //*variables
  const dispatch = useDispatch();
  let usersOptions = [];
  users.map((user) => {
    usersOptions = [
      ...usersOptions,
      {
        id: user.id,
        label: `${user.username}-${user.first_name} ${user.last_name}`,
      },
    ];
  });
  let responsableOptions = [];
  responsable &&
    responsable.map((user) => {
      responsableOptions = [
        ...responsableOptions,
        {
          id: user.id,
          label: `${user.username}-${user.first_name} ${user.last_name}`,
        },
      ];
    });
  //* Methods
  useEffect(() => {
    if (props.buttonClicked) {
      dispatch(getUsers({ limit: 10, offset: 0 }));
    }

    // dispatch(getResponsables({}));
  }, [props.buttonClicked]);

  useEffect(() => {
    let filters = {}
    if (userRoles.includes("Responsable_OnBoarding") || userRoles.includes("Responsable_OffBoarding")) {
      filters.usuario_x_empresa = "si"
    }
    if (props.buttonClicked) {
      if (props.tipo_workflow === 1) {
        filters.rol_responsable = "Responsable_OnBoarding"
        dispatch(getResponsables(filters));
      }
      if (props.tipo_workflow === 2) {
        filters.rol_responsable = "Responsable_OffBoarding"
        dispatch(getResponsables(filters));
      }
    }

  }, [props.buttonClicked, props.tipo_workflow])

  useEffect(() => {
    if (searchTerm.length > 0) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        dispatch(getUsers({ filter: searchTerm }));
      }, 500);
    } else {
      // Si no hay texto, cargar usuarios sin filtro
      dispatch(getUsers({ limit: 10, offset: 0 }));
    }
    // Limpia el timeout al desmontar
    return () => {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
    };
  }, [searchTerm, dispatch]);

  // useEffect(() => {
  //   console.log(workflowUsers);
  // }, [workflowUsers]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    if (userSelected.length === 0) {
      //setValidated(true);
      setIsUserValid(true);
      return;
    } else {
      //setValidated(false);
      setIsUserValid(false);
    }

    if (responsableSelected.length === 0) {
      //setValidated(true);
      setIsResponsableValid(true);
      return;
    } else {
      //setValidated(false);
      setIsResponsableValid(false);
    }
    try {
      const existItem = workflowUsers.find(
        (rowItem) =>
          rowItem.empleado.id === userSelected[0].id &&
          rowItem.responsable.id === responsableSelected[0].id
      );
      if (existItem) {
        toastr.info("El usuario y responsable ya han sido agregados", "", {
          progressBar: true,
          rtl: true,
        });
        return;
      }
      if (userSelected[0].id === responsableSelected[0].id) {
        toastr.info(
          "El usuario y el responsable, no pueden ser el mismo.",
          "",
          {
            progressBar: true,
            rtl: true,
          }
        );
        return;
      }
    } catch (error) {
      toastr.info("El usuario o responsable, no son validos", "", {
        progressBar: true,
        rtl: true,
      });
    }

    setWorkflowUsers([
      ...workflowUsers,
      { empleado: userSelected[0], responsable: responsableSelected[0] },
    ]);
    setUserSelected([]);
    setResponsableSelected([]);
  };

  const handleRemoveUserWork = (ind) => {
    const wUsers = workflowUsers.slice();
    wUsers.splice(ind, 1);
    setWorkflowUsers(wUsers);
    // props.handleClose();
  };

  const handleSaveWorkFlowEmployees = () => {
    let workflowUsersT = [];
    workflowUsers.map((item) =>
      workflowUsersT.push({
        empleado: item.empleado.id,
        responsable: item.responsable.id,
      })
    );

    const req = {
      empleados: workflowUsersT,
      workflow: props.item.id,
    };
    console.log("props item", props.item)
    dispatch(
      saveCopia(
        req,
        parseInt(props.item.tipo_workflow),
        // [props.item.tipo_workflow],
        props.offset,
        props.limit,
        props.filter,
        props.tipoBusqueda
      )
    );
    props.handleClose();
  };

  return (
    <Modal
      size="md"
      show={props.show}
      onHide={() => {
        props.handleClose();
        setUserSelected(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4 className="font-weight-bold text-uppercase m-0">
            <i
              className="flex-wrap material-icons"
              style={{ fontSize: "2rem", marginTop: "-.5rem" }}
            >
              workspaces
            </i>
            &nbsp;Crear Copia WorkFlow
          </h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            <Row>
              <Col>
                {!!copiaError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {copiaError}
                  </Alert>
                )}
                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                  <Row className="align-items-center">
                    <Col sm={loadingAuth ? 10 : 12}>
                      <Typeahead
                        isInvalid={isUserValid}
                        placeholder="Usuario"
                        options={usersOptions}
                        onChange={(selected) => setUserSelected(selected)}
                        selected={userSelected}
                        onInputChange={text => setSearchTerm(text)}
                      ></Typeahead>
                    </Col>
                    {loadingAuth && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Row>
                  {isUserValid && (
                    <small className="text-danger">**Campo requerido</small>
                  )}
                  <Row className="align-items-center mt-3">
                    <Col sm={responsableLoading ? 10 : 12}>
                      <Typeahead
                        isInvalid={isResponsableValid}
                        placeholder="Responsable"
                        options={responsableOptions}
                        onChange={(selected) =>
                          setResponsableSelected(selected)
                        }
                        selected={responsableSelected}
                      ></Typeahead>
                    </Col>
                    {responsableLoading && (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Row>
                  {isResponsableValid && (
                    <small className="text-danger">**Campo requerido</small>
                  )}
                  <Col className="mt-3 pl-1">
                    <Button
                      disabled={
                        responsableSelected === 0 || userSelected.length === 0
                      }
                      className="rounded"
                      variant="primary"
                      type="submit"
                    >
                      Agregar
                    </Button>
                  </Col>
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <div>
                  {loadingWorkFlow ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : workflowUsers.length > 0 ? (
                    <Card class="shadow-sm">
                      <div class="table-responsive">
                        <Table striped>
                          <thead>
                            <tr>
                              <th>Empleado</th>
                              <th>Responsable</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {workflowUsers.map((workflowUser, ind) => (
                              <tr key={workflowUser.empleado.id}>
                                <td>{workflowUser.empleado.label}</td>
                                <td>{workflowUser.responsable.label}</td>
                                <td>
                                  <Button
                                    variant="default"
                                    size="sm"
                                    className="ml-3"
                                    onClick={() => handleRemoveUserWork(ind)}
                                  >
                                    <i
                                      className="material-icons"
                                      style={{ fontSize: "1.3rem" }}
                                    >
                                      delete
                                    </i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Card>
                  ) : (
                    <Alert variant="info">
                      Aún no hay usuarios asignados a este WorkFlow.
                    </Alert>
                  )}
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="rounded-pill"
          variant="secondary"
          onClick={() => {
            setWorkflowUsers([]);
            props.handleClose();
          }}
        >
          Cancelar
        </Button>
        <Button
          disabled={workflowUsers.length === 0 || saveLoading}
          className="rounded-pill"
          variant="primary"
          type="button"
          onClick={() => {
            if (workflowUsers.length > 0) {
              handleSaveWorkFlowEmployees();
            }
          }}
        >
          {saveLoading ? (
            <Spinner
              className="mr-2"
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : null}
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WorkFlowEmployeesCopiaMasiva;